import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "input", "preview", "placeholder" ]

  connect() {
    this.originalSrc = null;
    // Store the original src if an avatar was rendered by the server
    if (this.previewTarget.dataset.hasAttachedAvatar === 'true' && this.previewTarget.src && !this.previewTarget.src.startsWith('blob:')) {
      this.originalSrc = this.previewTarget.src;
    }
    // ERB is now responsible for the initial hidden/visible state of preview and placeholder.
    // This connect method no longer manipulates .hidden class on initial load.
  }

  previewFile() {
    const file = this.inputTarget.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        this.previewTarget.src = event.target.result; // This will be a data URL (blob)
        this.previewTarget.classList.remove('hidden');
        if (this.hasPlaceholderTarget) {
          this.placeholderTarget.classList.add('hidden');
        }
      }
      reader.readAsDataURL(file);
    } else {
      // User cleared the file input. Revert to the initial server-rendered state.
      this.revertToInitialState();
    }
  }

  revertToInitialState() {
    if (this.previewTarget.dataset.hasAttachedAvatar === 'true' && this.originalSrc) {
      // If an avatar was originally attached, restore its src and visibility
      this.previewTarget.src = this.originalSrc;
      this.previewTarget.classList.remove('hidden');
      if (this.hasPlaceholderTarget) {
        this.placeholderTarget.classList.add('hidden');
      }
    } else {
      // No avatar was originally attached, or originalSrc is not available. Show placeholder.
      this.previewTarget.src = ""; // Clear any blob URL
      this.previewTarget.classList.add('hidden');
      if (this.hasPlaceholderTarget) {
        this.placeholderTarget.classList.remove('hidden');
      }
    }
  }
} 